import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import googleLibDiscover from './helpers/google-lib-discover-helper';
import './index.css';
import * as serviceWorker from './serviceWorker';

import ReduxProvider from './components/ReduxProvider';

ReactDOM.render(<ReduxProvider><App googleLib={ googleLibDiscover() } /></ReduxProvider>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
